// extracted by mini-css-extract-plugin
export default {"buttons":"Buttons_buttons__Qu0UE","button":"Buttons_button__COEJS","darkButton":"Buttons_darkButton__e6pzh","iconButton":"Buttons_iconButton__eMJJd"};